<div class="form-group jbm-autocomplete clearfix {{class}} {{className}}"
  [ngClass]="{'stacked': labelStacked, 'readonly': !editable, 'disabled': disabled}">
  <label *ngIf="labelCaption" for="{{id}}" class="{{labelClass}}" [ngClass]="{'col-form-label': !labelStacked }">
    {{labelCaption}}
    <span *ngIf="!editable">:</span>
    <span *ngIf="editable && required" class="asterix">*</span>
  </label>
  <div class="input-container {{inputClass}}" [ngClass]="{'data-value': !editable }">
    <label *ngIf="!editable" class="col-form-label">{{getDataValue()}}</label>
    <div *ngIf="editable" class="autocomplete-input">
      <input id="{{id}}" type="text" class="form-control" [ngClass]="{'form-control-sm': sm}" [value]="searchValue"
        [disabled]="disabled" [attr.maxlength]="maxlength>0 ? maxlength : null" [attr.placeholder]="placeholder"
        [attr.tabindex]="tabIndex!==null ? tabIndex : null" autocomplete="off" autocorrect="off"
        autocapitalize="none" spellcheck="false"
        (focus)="focus()"
        (input)="input($event)"
        (keydown)="keyDown($event)"
        (blur)="blur()">

      <div *ngIf="listOpen && !disabled" class="options">
        <div *ngIf="loading" class="option loading">{{'ui.loading'|translate}}...</div>

        <div *ngFor="let option of getMatchedOptions(); index as index" class="option"
          [ngClass]="{'active': index===activeOptionIndex}"
          (mousedown)="selectLookupOption(option, $event)">
          <ng-container *ngIf="optionTemplate; else defaultOptionTemplate"
            [ngTemplateOutlet]="optionTemplate"
            [ngTemplateOutletContext]="{ data: option }">
          </ng-container>
          <ng-template #defaultOptionTemplate>
            {{getDisplayValue(option)}}
          </ng-template>
        </div>

        <div *ngIf="!loading && getMatchedOptions().length===0" class="option empty">
          {{'ui.empty-view'|translate}}
        </div>
      </div>
    </div>
    <ng-content></ng-content>
  </div>
</div>
